import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type { ApiPayload, PaasChartCorrectionValue, PaasStatusResponse } from '@/api/ApiTypes';


const paasStatusGet = (
	handler: (responseData: PaasStatusResponse) => void,
): void => {
	axios.get('/paas/status_get/').then(extractData(handler)).catch(logError);
};


const paasTestDataCreate = (
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/create_test_data/', {}).then(extractData(handler)).catch(logError);
};


const paasTaskReview = (
	id: number,
	handler: (responseData: ApiPayload & { comparisons?: unknown[] }) => void,
): void => {
	axios.get('/paas/task/review/', { params: { id } }).then(extractData(handler)).catch(logError);
};


const paasTaskApply = (
	ids: number[],
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/apply/', { ids }).then(extractData(handler)).catch(logError);
};


const paasTaskIgnore = (
	id: number,
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/ignore/', { id }).then(extractData(handler)).catch(logError);
};


const paasTaskApplyFromChart = (
	correctionValues: PaasChartCorrectionValue[],
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/apply_from_chart/', {
		values: correctionValues.map(item => ({
			mountpoint: item.mountpoint,
			dates: item.dates,
		})),
	}).then(extractData(handler)).catch(logError);
};


const paasTaskAddManual = (
	baseStationId: number,
	quickMode: boolean,
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/add_manual/', {
		base_station_id: baseStationId,
		quick_mode: quickMode,
	}).then(extractData(handler)).catch(logError);
};


const paasTaskAddFromSettings = (
	handler: (responseData: ApiPayload) => void,
): void => {
	axios.post('/paas/task/add_from_settings/', {}).then(extractData(handler)).catch(logError);
};


export default {
	paasStatusGet,
	paasTestDataCreate,
	paasTaskReview,
	paasTaskApply,
	paasTaskIgnore,
	paasTaskApplyFromChart,
	paasTaskAddManual,
	paasTaskAddFromSettings,
};
